import { VendorDetailsFormFields } from '@/types/vendors.types';

// TODO: still not implemented for extended unmanaged https://meliorisk.atlassian.net/browse/ME-32708
export const getUpdateVendorPayload = (data: VendorDetailsFormFields) => {
  const { companyName, fullName, email, phone } = data;

  return {
    name: companyName || '',
    contact: {
      name: fullName || '',
      email: email || '',
      phoneNumber: phone || '',
    },
  };
};
